import React, { useMemo } from 'react';
import { DefaultInputPropTypes, TextInput, useInputHelper } from 'framework/form';

const AzureIdInput = (props: DefaultInputPropTypes<string>) => {
  const { getValue } = useInputHelper(props);

  const isDisabled = useMemo(() => {
    return !!getValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <TextInput {...props} disabled={isDisabled} />;
};

export default AzureIdInput;
